module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAcklEQVRYw+2WQQ6AIBDEeB6/8q/wkDHGGMXEqMRZObQ3Lu0FdkkJAGAwlFX1lqr8PFDUQzlZputAJ62+PX8cWPTGwKq3BTa9KbDrLYGj3hBo9Y6ACBAY/praH1rAqAgYdgHjOmDh3K9M+9J3f1sAAH5iBuCdHmsvth/6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/icon-camera.png
// module id = 1341
// module chunks = 0